import React from 'react';

class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Widget crashed' };
  }

  componentDidCatch(error, info) {
    console.error('Dashboard widget crashed:', error, info);
  }

  reset = () => {
    this.setState({ hasError: false, message: '' });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="dashboard-widget dashboard-widget-crash">
          <div className="dashboard-widget-header">
            <span className="dashboard-widget-title">Widget error</span>
          </div>
          <div className="dashboard-widget-body">
            <div className="dashboard-widget-state dashboard-widget-error" role="alert">
              <p className="dashboard-widget-error-text">{this.state.message}</p>
              <button type="button" className="dashboard-widget-retry" onClick={this.reset}>
                Try again
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default WidgetErrorBoundary;
